/**
 * Fechas civiles en la zona horaria DEL USUARIO.
 *
 * En GestorPro una fecha 'YYYY-MM-DD' es una fecha CIVIL —el día que el usuario vio el
 * movimiento en su banco—, no un instante. JavaScript tiene dos representaciones y
 * mezclarlas desplaza el día según dónde esté el usuario:
 *
 *  - `new Date('2026-08-01')` se interpreta como MEDIANOCHE UTC. Leída con getters
 *    locales devuelve el 31 de julio en todo huso al oeste de Greenwich (América).
 *  - `new Date(2026, 7, 1).toISOString()` construye medianoche LOCAL y la imprime en
 *    UTC: al este de Greenwich (España, CEST) sale '2026-07-31'.
 *
 * Regla única, sin excepciones: parsear con `parseLocalDate` y serializar con
 * `toLocalISODate` / `toLocalISOMonth`. Nunca `new Date(iso)` + getters locales, nunca
 * un `Date` construido en local + `toISOString()`.
 *
 * (El motor de IRPF es el caso aparte legítimo: trabaja íntegramente en UTC —construye
 * con `Date.UTC` y lee con `toISOString`—, así que es coherente consigo mismo y no
 * depende del huso del usuario.)
 */

/**
 * Parsea una fecha civil ('YYYY-MM-DD', opcionalmente con sufijo de hora) como
 * MEDIANOCHE LOCAL. Cualquier otro formato cae al parser nativo.
 */
export function parseLocalDate(dateStr: string): Date {
    // 'YYYY-MM-DD' optionally followed by a time suffix ('T…' / ' …'): parse the DATE part as
    // LOCAL midnight. This also covers full ISO datetimes (sanitizeTransaction defaults to
    // `new Date().toISOString()`), which the previous split('-') turned into Invalid Date.
    const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s].*)?$/.exec(dateStr);
    if (m) {
        return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    }
    return new Date(dateStr);
}

/** Fecha civil local en 'YYYY-MM-DD'. Contrapartida exacta de `parseLocalDate`. */
export function toLocalISODate(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/** Mes civil local en 'YYYY-MM' (etiquetas de series y cuadros de amortización). */
export function toLocalISOMonth(d: Date): string {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** HOY en la zona del usuario, en 'YYYY-MM-DD'. */
export function todayISO(now: Date = new Date()): string {
    return toLocalISODate(now);
}
